<template>
  <v-container class="px-0 py-0" fluid>
    <v-row dense>
      <v-col>
        <InspCharacForm />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import InspCharacForm from '@/components/organisms/master/form/InspCharacForm'

export default {
  name: 'InspectionCharacteristicsPage',
  components: {
    InspCharacForm,
  },
}
</script>
